// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"bc20edac","268":"bee9661f","318":"efd67436","841":"adbbd91f","922":"96d85849"}[chunkId] + ".chunk.js";
};